import { Directive, Optional, Inject, ViewContainerRef, ComponentFactoryResolver, ComponentRef, Input, Host, OnDestroy, OnInit } from '@angular/core';
import { NgControl, ControlContainer } from '@angular/forms';
import { merge, EMPTY, Observable, Subscription } from 'rxjs';
import { ControlErrorComponent } from './control-error/control-error.component';
import { ControlErrorContainerDirective } from './control-error-container.directive';
import { FormSubmitDirective } from './form-submit.directive';
import { FormErrorsService } from './form-errors.service';

@Directive({
  selector: '[formControl], [formControlName]'
})
export class ControlErrorsDirective implements OnInit, OnDestroy {

  @Input() customErrors = {};

  ref: ComponentRef<ControlErrorComponent>;
  container: ViewContainerRef;
  submit$: Observable<Event>;
  subscription: Subscription;
  showErrors = false;

  constructor(
    private vcr: ViewContainerRef,
    private resolver: ComponentFactoryResolver,
    @Optional() controlErrorContainer: ControlErrorContainerDirective,
    private errors: FormErrorsService,
    @Optional() @Host() private form: FormSubmitDirective,
    private controlDir: NgControl
  ) {
    this.container = controlErrorContainer ? controlErrorContainer.vcr : vcr;
    this.submit$ = this.form ? this.form.submit$ : EMPTY;
  }

  ngOnInit() {
    this.subscription = merge(
      this.submit$,
      this.control.valueChanges
    ).subscribe((v) => {
      if (v instanceof Event) {
        this.showErrors = true;
      } else if (v === null) {
        this.showErrors = false;
        this.setError(null);
      }

      const controlErrors = this.control.errors;


      if (controlErrors && this.showErrors) {
        const firstKey = Object.keys(controlErrors)[0];
        // Retrieve the function that will generate the error
        // message for a specific key.
        let getError = this.errors.all[firstKey];
        if (!getError) {
          getError = this.errors.generic;
        }
        const text = this.customErrors[firstKey] || getError(controlErrors[firstKey]);
        this.setError(text);
      } else if (this.ref) {
        this.setError(null);
      }
    });
  }

  get control() {
    return this.controlDir.control;
  }

  setError(text: string) {
    if (!this.ref) {
      const factory = this.resolver.resolveComponentFactory(ControlErrorComponent);
      this.ref = this.container.createComponent(factory);
    }

    this.ref.instance.text = text;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}